import { render, staticRenderFns } from "./SubmissionFormLanguage.vue?vue&type=template&id=a1d0e744&scoped=true&"
import script from "./SubmissionFormLanguage.vue?vue&type=script&lang=js&"
export * from "./SubmissionFormLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionFormLanguage.vue?vue&type=style&index=0&id=a1d0e744&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d0e744",
  null
  
)

export default component.exports